import React, { Component } from 'react';
import { SocialMediaStatus, WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import CaseRadialProgressContainer from '../../custom/radial-progress-bar/CaseRadialProgressContainer';
import CaseChartIndicatorComponent from '../../investigation/case/widget/CaseChartIndicatorComponent';
import moment from 'moment';
import WatchlistCustomerComponent from '../detail/WatchlistCustomerComponent';

class WatchlistAlertSocialMediaComponent extends Component<Props> {
  render() {
    const { socialMediaResponse, loading } = this.props;
    if (!loading && socialMediaResponse == undefined) {
      return (
        <div className={'p-5 max-h-[calc(100vh-16rem)] w-full'}>
          <div className={'w-full h-full flex flex-col items-center justify-center px-4 bg-main-gray border rounded-xl'}>
            <div className={'w-1/3 flex flex-col items-center justify-center gap-y-1'}>
              <img src={'/icons/empty.svg'} alt='empty' className={'w-[120px] h-[120px]'} />
              <span className={'text-black text-[16px]'}>Social media scan did not occur</span>
              Social media scanning could not be performed because you did not enter your email and phone number. To search, enter your email and phone number
              when searching!
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className='max-h-[calc(100vh-16rem)] p-5 w-full overflow-y-scroll'>
        <div className={'grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-5 gap-y-5 gap-x-5 px-5 py-5 w-full bg-[#F9FAFB] border border-[#E0E4E8] rounded-xl'}>
          <div className={'flex col-span-1  lg:grid-cols-1 xl:grid-cols-1 justify-center items-center w-full h-full'}>
            <CaseRadialProgressContainer
              header={'Social Media Score'}
              subHeader={'Social media scanning score'}
              score={Number(socialMediaResponse?.summary.score || 0)}
              progressColor={this.getProgressColor(socialMediaResponse?.summary.score)}
              labelColor={this.getLabelColor(socialMediaResponse?.summary.score)}
              loading={socialMediaResponse == undefined}
              maxScore={100}
            />
          </div>
          <div className={'flex flex-col col-span-1 lg:col-span-1 xl:col-span-2 gap-y-5'}>
            <CaseChartIndicatorComponent
              icon={'registered-icon-1'}
              score={`${socialMediaResponse?.socialMedia.accounts?.filter((socialMedia: any) => socialMedia.status == SocialMediaStatus.FOUND).length || 0} Social Media`}
              label={'Registered Social Media'}
            />
            <CaseChartIndicatorComponent
              icon={'not-registered-icon-1'}
              score={`${socialMediaResponse?.socialMedia.accounts?.filter((socialMedia: any) => socialMedia.status == SocialMediaStatus.NOT_FOUND).length || 0} Social Media`}
              label={'Not Registered Social Media'}
            />
          </div>
          <div className={'flex flex-col col-span-1 lg:col-span-1 xl:col-span-2 gap-y-5'}>
            <CaseChartIndicatorComponent
              icon={'data-breaches-icon-1'}
              score={`${socialMediaResponse?.socialMedia.breaches.length || 0} Data Breaches`}
              label={'Data Breaches'}
            />
            <CaseChartIndicatorComponent
              icon={'seen-icon-1'}
              score={socialMediaResponse?.summary.firstSeen ? moment(socialMediaResponse?.summary.firstSeen).format('LL') : '-'}
              label={'First Seen'}
            />
          </div>
        </div>
        <div className={'pt-4'}>
          <WatchlistCustomerComponent customerResponse={socialMediaResponse} customerLoading={socialMediaResponse == undefined} />
        </div>
      </div>
    );
  }

  private getLabelColor = (score: number | undefined = 0): string => {
    if (score <= 30) {
      return 'text-[#7FCD8C]';
    } else if (score > 30 && score <= 70) {
      return 'text-[#F19E46]';
    } else {
      return 'text-[#D33632]';
    }
  };

  private getProgressColor = (score: number | undefined = 0): string => {
    if (score <= 30) {
      return 'gradient-low';
    } else if (score > 30 && score <= 70) {
      return 'gradient-medium';
    } else {
      return 'gradient-high';
    }
  };
}

interface Props {
  socialMediaResponse: WatchlistCustomerDomains | undefined;
  loading: boolean;
}

export default WatchlistAlertSocialMediaComponent;
